export enum RoutingPath {
  AdminLoginAspx = '/Admin/Login.aspx',
  ApAdministrators = '/AP/Administrators',
  ApAppsDomains = '/AP/Apps/Domains',
  ApAppsGeneral = '/AP/Apps/General',
  ApAuditLog = '/AP/AuditLog',
  ApBackupComputers = '/AP/Backup/Computers',
  ApBackupHistory = '/AP/BackupHistory',
  ApBackupHistoryLegacy = '/AP/BackupHistoryLegacy',
  ApBackupTemplates = '/AP/BackupTemplates',
  ApBranding = '/AP/Branding',
  ApCalc = '/AP/calc.aspx',
  ApCompanies = '/AP/Companies',
  ApComputers = '/AP/Computers',
  ApConnectWiseNew = '/AP/ConnectWiseNew',
  ApDashboard = '/AP/Dashboard',
  ApDefaultAspx = '/AP/Default.aspx',
  ApEditAccountAspx = '/AP/EditAccount.aspx',
  ApEmailService = '/AP/EmailService',
  ApGettingStart = '/AP/GettingStart',
  ApGlobalAgentOptions = '/AP/GlobalAgentOptions',
  ApHelp = '/AP/Help',
  ApLicenses = '/AP/Licenses',
  ApLicensesAspx = '/AP/Licenses.aspx',
  ApMonitoring = '/AP/Monitoring',
  ApNewBackupHistory = '/AP/newBackupHistory',
  ApNotFound = '/AP/NotFound',
  ApNotifications = '/AP/Notifications',
  ApPlanReportSettings = '/AP/PlanReportSettings',
  ApRDStatistics = '/AP/RDStatistics',
  ApRMMComputers = '/AP/RMM/Computers',
  ApRMMAlertsHistory = '/AP/RMMAlertsHistory',
  ApRMMGroupTaskAction = '/AP/RMMGroupTaskAction',
  ApRestore2Cloud = '/AP/Restore2Cloud',
  ApScheduledReports = '/AP/ScheduledReports',
  ApSettings = '/AP/Settings',
  ApSnmp = '/AP/Snmp',
  ApSSL = '/AP/SSL',
  ApStorages = '/AP/StorageAccounts',
  ApStorageCapacityReport = '/AP/StorageCapacityReport',
  ApUserListAspx = '/AP/UserList.aspx',
  ApUsers = '/AP/Users',
  LoginAspx = 'Login.aspx',
  Maintenance = 'AP/Maintenance',
  NotificationErrors = 'AP/NotificationErrors',
  OnlineAccess = '/OnlineAccess',
  OnlineAccessNotFound = '/NotFound',
  OnlineAccessWebConnect = '/OnlineAccess/WebConnect',
  RMMAlertCustomisation = 'AP/RMMAlertCustomisation',
  RMMNotifications = '/AP/RMMNotifications',
  RMMScriptLibrary = '/AP/ScriptLibrary',
  SupportPortal = '/AP/SupportPortal',
}
